import React from 'react'
import {Box, Typography} from "@mui/material";
import useStyles from "../../assets/styles/HomeStyles";


const DQProAlignment= ()=>{
    const classes = useStyles();

    return (
        <>
            <Box className={classes.pageContainer} style={{margin:'auto'}}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom:{sm:2, xs:1}, marginTop:{xs:'55px', sm:'0px'} }} className={classes.title}>
                    Coming Soon
                </Typography>
            </Box>
        </>
    )
}

export default DQProAlignment;